import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const UserRequest = {
  // Fetch filtered list of users
  userFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getUserFilterSet}`, {
      withCredentials: true,
      params: {
        roleId: 1,
      },
    }),

  // Fetch a single user by ID
  getUserById: (userId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getUserById}/${userId}`, // Send id directly in the URL
      {
        withCredentials: true,
      }
    ),
  // Fetch the list of all vendors
  vendorList: () =>
    api.get(`${API_URL.BASEURL}${API_URL.getVendorList}`, {
      withCredentials: true,
    }),

  // Fetch the list of all drivers
  driverList: (vendorId) =>
    api.get(
      `${API_URL.BASEURL}${API_URL.getDriverList}?vendorId=${vendorId}`, // Send id directly in the URL
      {
        withCredentials: true,
      }
    ),

  // Create a new user
  createUser: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createUser}`, values, {
      withCredentials: true,
    }),

  // Update an existing user by ID
  updateUser: (userId, values) =>
    api.put(
      `${API_URL.BASEURL}${API_URL.updateUser}/${userId}`, // Send ID directly in the URL
      values,
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json", // Ensure that the request body is being treated as JSON
        },
      }
    ),
};

export default UserRequest;
